import { get } from 'lodash'
import { connect } from 'react-redux'

import { auth } from '../../../../constants/actions'
import withUrlParams from '../../../../hoc/withUrlParams'
import VerifyAccountComponent from './component'

export const mapStateToProps = state => ({
  verified: get(state, 'auth.verified'),
  verifyEmailMsg: get(state, 'auth.verifyEmailMsg.message'),
  formType: get(state, 'formSettings.formType'),
})

export default connect(mapStateToProps, {
  verifyEmail: auth.verifyEmail,
})(withUrlParams(VerifyAccountComponent))
